/** The style bar's arrow tools: its line (solid, dashed, dotted) and no head. */
import { For, type JSX } from "solid-js";
import type { Bar } from "./bar";

/** The lines an arrow may be drawn with, the usual one first. */
const LINES = ["solid", "dashed", "dotted"] as const;

/** Line and head. */
export function ArrowTools(props: { bar: Bar }): JSX.Element {
  const { value, set } = props.bar;
  return (
    <>
      <For each={LINES}>
        {(line) => (
          <button type="button" data-style="line" data-value={line} aria-pressed={(value("line") || "solid") === line} onClick={() => set("line", line === "solid" ? "" : line)}>
            {line}
          </button>
        )}
      </For>
      <button type="button" data-style="head" data-value="none" aria-pressed={value("head") === "none"} onClick={() => set("head", "none")}>
        no head
      </button>
    </>
  );
}
